import React from 'react';
import './App.css';
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';

function App() {
  // Simple routing based on current path
  const getCurrentPage = () => {
    const path = window.location.pathname;
    
    switch (path) {
      case '/about':
        return <About />;
      case '/contact':
        return <Contact />;
      case '/':
      default:
        return <Home />;
    }
  };

  return (
    <div className="App">
      {getCurrentPage()}
    </div>
  );
}

export default App;